/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutocompleteAddressResponseBaseResponse as ModelsCustomerAutocompleteAddressResponseBaseResponse } from '../../models/Models/Customer/autocomplete-address-response-base-response';

export interface V3PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml$Params {
  query?: string;
  applicationId: string;
}

export function v3PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml(http: HttpClient, rootUrl: string, params: V3PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>;
    })
  );
}

v3PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml.PATH = '/v3/public/application/{applicationId}/getAddressAutocomplete';
